import { IObjectTranslatable, TextLineConverter, JoinTextRelationalItemTranslator, TextAlignKindsTranslator, HtmlColorCodeTranslator, RelationalActionTranslator } from ".";
import { IItem, JoinTextItem } from "../../../../domain/document/items";
import { ITypeDefinable, BeanTypes } from "../beans/items";
import { IJoinTextItemBean } from "../beans/items/IJoinTextItemBean";
import { Color, TextStyle, Rectangle, Point, Size } from "../../../../domain/drawing";

export class JoinTextItemTranslator implements IObjectTranslatable {
  toItem(item: ITypeDefinable, formatId: number, groupId: number, documentId: number, executionMode: string): IItem {
    const bean = item as IJoinTextItemBean;
    const result = new JoinTextItem(TextLineConverter.convert(bean.text, !!bean.multiLine, !bean.supportedFreeText));
    result.privateId = (bean as any).privateId; // フロントエンド独自パラメータ.
    result.uniqueKey = bean.uniqueKey;
    result.id = bean.id;
    result.sectionObjectUid = bean.sectionObjectUid;
    result.isEditable = true; // TODO:特に問題なければプロパティを削除する
    result.isAdditional = !!bean.isAdditional;
    result.isDeleted = !!bean.isDeleted;
    result.isVisible = !!bean.isVisible;
    result.typeDetail = bean.typeDetail;
    result.viewTitle = bean.viewTitle;
    result.printBehavior.shouldPrint = !!bean.printVisible;
    result.printBehavior.shouldPreview = !!bean.previewVisible;
    result.name = bean.name;
    result.geometry.rectangle = new Rectangle(new Point(bean.x, bean.y), new Size(bean.width, bean.height));
    result.textStyle = new TextStyle(new Color(bean.textColor), TextAlignKindsTranslator.toKind(bean.textAlign), bean.textFontSize, bean.adjustedTextFontSize, bean.textFontName, bean.textLineHeight, !!bean.multiLine);
    result.isFreeInputable = bean.supportedFreeText;
    result.shouldInputFree = bean.enabledFreeText;
    result.joinTextRelationalItems = JoinTextRelationalItemTranslator.toJoinTextRelationalItems(bean.joinTextRelationalItems);
    result.paintStyle = HtmlColorCodeTranslator.toPaintStyleFill(bean.backColor);
    result.enabledAutoAdjustFontSize = !!bean.enabledAutoAdjustFontSize;
    result.toolTip = bean.toolTip;
    result.enableLengthCheck = !!bean.lengthCheck;
    result.lengthChecklength = bean.length;
    result.shouldAppendNewLine = !!bean.enabledAppendNewLine;
    result.dacsProcessType = bean.dacsProcessType;
    result.dacsItemName = bean.dacsItemName;
    result.dacsItemCode = bean.dacsItemCode;
    result.actions = RelationalActionTranslator.toItems(bean.relationalItems);
    result.isNaturalViewEnable = bean.naturalView;
    result.naturalText = bean.naturalText;
    return result;
  }

  toBean(item: IItem): ITypeDefinable {
    const target = item as JoinTextItem;
    const bean: IJoinTextItemBean = {
      type: BeanTypes.JoinText,
      uniqueKey: target.uniqueKey,
      id: target.id,
      sectionObjectUid: target.sectionObjectUid,
      isVisible: target.isVisible,
      printVisible: target.printBehavior.shouldPrint,
      previewVisible: target.printBehavior.shouldPreview,
      x: target.geometry.rectangle.x,
      y: target.geometry.rectangle.y,
      width: target.geometry.rectangle.width,
      height: target.geometry.rectangle.height,
      isAdditional: target.isAdditional,
      isDeleted: target.isDeleted,
      name: target.name,
      textColor: HtmlColorCodeTranslator.fromColor(target.textStyle.color),
      textFontName: target.textStyle.fontFamily,
      textFontSize: target.textStyle.baseFontSize,
      textLineHeight: target.textStyle.lineHeight,
      textAlign: TextAlignKindsTranslator.fromKind(target.textStyle.textAlign),
      backColor: HtmlColorCodeTranslator.fromPaintStyle(target.paintStyle),
      supportedFreeText: target.isFreeInputable,
      enabledFreeText: target.shouldInputFree,
      text: target.value,
      enabledAutoAdjustFontSize: target.enabledAutoAdjustFontSize,
      lengthCheck: target.enableLengthCheck,
      length: target.lengthChecklength,
      adjustedTextFontSize: target.textStyle.adjustedFontSize,
      multiLine: target.textStyle.isMultiLine,
      joinTextRelationalItems: null,      // 返却不要
      toolTip: target.toolTip,
      enabledAppendNewLine: target.shouldAppendNewLine,
      typeDetail: target.typeDetail,
      viewTitle: target.viewTitle,
      dacsProcessType: target.dacsProcessType,
      dacsItemName: target.dacsItemName,
      dacsItemCode: target.dacsItemCode,
      relationalItems: null,
      naturalView: target.isNaturalViewEnable,
      naturalText: target.naturalText,
    };
    return bean;
  }
}
